import React from "react";
import SignupModal from "../../components/SignupModal/SignupModal";
import { SignupStyle } from "./SignupStyle";

const Signup = () => {
  return (
   <SignupStyle>
     <SignupModal/>
   </SignupStyle>
  );
};

export default Signup;
